<template>
  <div>
    <div>
      <Filtro @filtro="makeFiltro"></Filtro>
    </div>
    <div
      v-if="
        $can('Leitura Carteira Completa', 'Associados') ||
        $can('Leitura Carteira Corretora', 'Associados')
      "
    >
      <vx-card v-if="itensCards.res" title="Status" class="bg-secondary3 mb-5">
        <div class="carousel-statistic">
          <div class="vx-row">
            <div
              class="vx-col p-2 w-full lg:w-3/12"
              @click="exibeResumoPropostas(STATUS_PROPOSTA.FINALIZADO.name)"
            >
              <statistics-card
                iconPack="feather"
                icon="icon-activity"
                color="#29C770"
                bg="#E3F7EA"
                titulo="Vendas Feitas"
                :valorTotal="`${this.itensCards.res.propostasPeriodo.qtdFinalizadas}`"
                :valorTotalAnterior="`${this.itensCards.res.propostasPeriodoAnterior.qtdFinalizadas}`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.propostasPeriodo.qtdFinalizadas,
                  this.itensCards.res.propostasPeriodoAnterior.qtdFinalizadas,
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>

            <div
              class="vx-col p-2 w-full lg:w-3/12"
              @click="exibeResumoPropostas(STATUS_PROPOSTA.PENDENTE.name)"
            >
              <statistics-card
                iconPack="feather"
                icon="icon-briefcase"
                color="#0090cf"
                bg="#e2f6fd"
                titulo="Pendentes"
                :valorTotal="`${this.itensCards.res.propostasPeriodo.qtdPendentes}`"
                :valorTotalAnterior="`${this.itensCards.res.propostasPeriodoAnterior.qtdPendentes}`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.propostasPeriodo.qtdPendentes,
                  this.itensCards.res.propostasPeriodoAnterior.qtdPendentes,
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>

            <div
              class="vx-col p-2 w-full lg:w-3/12"
              @click="
                exibeResumoPropostas(STATUS_PROPOSTA.AGUARDANDO_APROVACAO.name)
              "
            >
              <statistics-card
                iconPack="feather"
                icon="icon-briefcase"
                color="#FF9E43"
                bg="#FFF0E5"
                titulo="Aguardando Aprovação"
                :valorTotal="`${this.itensCards.res.propostasPeriodo.qtdAguardandoAprovacao}`"
                :valorTotalAnterior="`${this.itensCards.res.propostasPeriodoAnterior.qtdAguardandoAprovacao}`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.propostasPeriodo.qtdAguardandoAprovacao,
                  this.itensCards.res.propostasPeriodoAnterior
                    .qtdAguardandoAprovacao,
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>

            <div
              class="vx-col p-2 w-full lg:w-3/12"
              @click="exibeResumoPropostas(STATUS_PROPOSTA.EM_PRE_ANÁLISE.name)"
            >
              <statistics-card
                iconPack="feather"
                icon="icon-briefcase"
                color="#6800CF"
                bg="#FDE2F7"
                titulo="Pré Análise"
                :valorTotal="`${this.itensCards.res.propostasPeriodo.qtdPreAnalise}`"
                :valorTotalAnterior="`${this.itensCards.res.propostasPeriodoAnterior.qtdPreAnalise}`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.propostasPeriodo.qtdPreAnalise,
                  this.itensCards.res.propostasPeriodoAnterior.qtdPreAnalise,
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>

            <div
              class="vx-col p-2 w-full lg:w-3/12"
              @click="
                exibeResumoPropostas(STATUS_PROPOSTA.EM_PROCESSO_VISTORIA.name)
              "
            >
              <statistics-card
                iconPack="feather"
                icon="icon-briefcase"
                color="#378d8a"
                bg="#d4fffd"
                titulo="Processo de Vistoria"
                :valorTotal="`${this.itensCards.res.propostasPeriodo.qtdProcessoVistoria}`"
                :valorTotalAnterior="`${this.itensCards.res.propostasPeriodoAnterior.qtdProcessoVistoria}`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.propostasPeriodo.qtdProcessoVistoria,
                  this.itensCards.res.propostasPeriodoAnterior
                    .qtdProcessoVistoria,
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>

            <div
              class="vx-col p-2 w-full lg:w-3/12"
              @click="exibeResumoPropostas(STATUS_PROPOSTA.RECUSADA.name)"
            >
              <statistics-card
                iconPack="feather"
                icon="icon-briefcase"
                color="#872e27"
                bg="#ffcbca"
                titulo="Recusada"
                :valorTotal="`${this.itensCards.res.propostasPeriodo.qtdRecusadas}`"
                :valorTotalAnterior="`${this.itensCards.res.propostasPeriodoAnterior.qtdRecusadas}`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.propostasPeriodo.qtdRecusadas,
                  this.itensCards.res.propostasPeriodoAnterior.qtdRecusadas,
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>

            <div
              class="vx-col p-2 w-full lg:w-3/12"
              @click="exibeResumoPropostas(STATUS_PROPOSTA.EM_TRANSMISSAO.name)"
            >
              <statistics-card
                iconPack="feather"
                icon="icon-briefcase"
                color="#a4a4a4"
                bg="#e5e5e5"
                titulo="Em Aberto"
                :valorTotal="`${this.itensCards.res.propostasPeriodo.qtdEmAberto}`"
                :valorTotalAnterior="`${this.itensCards.res.propostasPeriodoAnterior.qtdEmAberto}`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.propostasPeriodo.qtdEmAberto,
                  this.itensCards.res.propostasPeriodoAnterior.qtdEmAberto,
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>
          </div>
        </div>
      </vx-card>

      <vx-card
        v-if="itensCards.res"
        title="Financeiro"
        class="bg-secondary2 mb-5"
      >
        <div class="carousel-statistic">
          <div class="vx-row">
            <div class="vx-col p-2 w-full lg:w-3/12">
              <statistics-card
                iconPack="feather"
                icon="icon-dollar-sign"
                color="#0090cf"
                bg="#e2f6fd"
                titulo="Projeção Mensal"
                :valorTotal="`${formataReal(
                  this.itensCards.res.financeiroPeriodo.projecaoMensal,
                )}`"
                :valorTotalAnterior="`${formataReal(
                  this.itensCards.res.financeiroPeriodoAnterior.projecaoMensal,
                )}`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.financeiroPeriodo.projecaoMensal,
                  this.itensCards.res.financeiroPeriodoAnterior.projecaoMensal,
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>
            <div class="vx-col p-2 w-full lg:w-3/12">
              <statistics-card
                iconPack="feather"
                icon="icon-dollar-sign"
                color="#0090cf"
                bg="#e2f6fd"
                titulo="Projeção Adesão"
                :valorTotal="`${formataReal(
                  this.itensCards.res.financeiroPeriodo.projecaoAdesao,
                )}`"
                :valorTotalAnterior="`${formataReal(
                  this.itensCards.res.financeiroPeriodoAnterior.projecaoAdesao,
                )}`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.financeiroPeriodo.projecaoAdesao,
                  this.itensCards.res.financeiroPeriodoAnterior.projecaoAdesao,
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>
            <div class="vx-col p-2 w-full lg:w-3/12">
              <statistics-card
                iconPack="feather"
                icon="icon-trending-down"
                color="#0090cf"
                bg="#e2f6fd"
                :titulo="`Diferença Projeção `"
                :valorTotal="`${formataReal(
                  this.itensCards.res.financeiroPeriodo.projecaoAdesao -
                    (this.itensCards.res.financeiroPeriodo.valorTotalBoletos +
                      this.itensCards.res.financeiroPeriodo
                        .valorTotalNaoGerados),
                )}`"
                :valorTotalAnterior="`${formataReal(
                  this.itensCards.res.financeiroPeriodoAnterior.projecaoAdesao -
                    (this.itensCards.res.financeiroPeriodoAnterior
                      .valorTotalBoletos +
                      this.itensCards.res.financeiroPeriodoAnterior
                        .valorTotalNaoGerados),
                )}`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.financeiroPeriodo.projecaoAdesao -
                    (this.itensCards.res.financeiroPeriodo.valorTotalBoletos +
                      this.itensCards.res.financeiroPeriodo
                        .valorTotalNaoGerados),
                  this.itensCards.res.financeiroPeriodoAnterior.projecaoAdesao -
                    (this.itensCards.res.financeiroPeriodoAnterior
                      .valorTotalBoletos +
                      this.itensCards.res.financeiroPeriodoAnterior
                        .valorTotalNaoGerados),
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>

            <div
              class="vx-col p-2 w-full lg:w-3/12"
              @click="exibeResumoFinanceiro('Gerados')"
            >
              <statistics-card
                iconPack="feather"
                icon="icon-trending-up"
                color="#FF9E43"
                bg="#FFF0E5"
                :titulo="`${this.itensCards.res.financeiroPeriodo.qtdTotalBoletos} Boletos Gerados`"
                :valorTotal="`${formataReal(
                  this.itensCards.res.financeiroPeriodo.valorTotalBoletos,
                )}`"
                :valorTotalAnterior="`${formataReal(
                  this.itensCards.res.financeiroPeriodoAnterior
                    .valorTotalBoletos,
                )}`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.financeiroPeriodo.valorTotalBoletos,
                  this.itensCards.res.financeiroPeriodoAnterior
                    .valorTotalBoletos,
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>

            <div
              class="vx-col p-2 w-full lg:w-3/12"
              @click="exibeResumoFinanceiro('Pagos')"
            >
              <statistics-card
                iconPack="feather"
                icon="icon-check"
                color="#29C770"
                bg="#E3F7EA"
                :titulo="`${this.itensCards.res.financeiroPeriodo.qtdTotalPagos} Boletos Pagos`"
                :valorTotal="`${formataReal(
                  this.itensCards.res.financeiroPeriodo.valorTotalBoletosPagos,
                )}`"
                :valorTotalAnterior="`${formataReal(
                  this.itensCards.res.financeiroPeriodoAnterior
                    .valorTotalBoletosPagos,
                )}`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.financeiroPeriodo.valorTotalBoletosPagos,
                  this.itensCards.res.financeiroPeriodoAnterior
                    .valorTotalBoletosPagos,
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>

            <div
              class="vx-col p-2 w-full lg:w-3/12"
              @click="exibeResumoFinanceiro('Em Aberto')"
            >
              <statistics-card
                iconPack="feather"
                icon="icon-info"
                color="#FF9E43"
                bg="#FFF0E5"
                :titulo="`${this.itensCards.res.financeiroPeriodo.qtdTotalAberto} Boletos Em Aberto`"
                :valorTotal="`${formataReal(
                  this.itensCards.res.financeiroPeriodo.valorTotalAberto,
                )}`"
                :valorTotalAnterior="`${formataReal(
                  this.itensCards.res.financeiroPeriodoAnterior
                    .valorTotalAberto,
                )}`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.financeiroPeriodo.valorTotalAberto,
                  this.itensCards.res.financeiroPeriodoAnterior
                    .valorTotalAberto,
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>

            <div
              class="vx-col p-2 w-full lg:w-3/12"
              @click="exibeResumoFinanceiro('Vencidos')"
            >
              <statistics-card
                iconPack="feather"
                icon="icon-calendar"
                color="#872e27"
                bg="#ffcbca"
                :titulo="`${this.itensCards.res.financeiroPeriodo.qtdTotalVencido} Boletos Vencidos`"
                :valorTotal="`${formataReal(
                  this.itensCards.res.financeiroPeriodo.valorTotalVencido,
                )}`"
                :valorTotalAnterior="`${formataReal(
                  this.itensCards.res.financeiroPeriodoAnterior
                    .valorTotalVencido,
                )}`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.financeiroPeriodo.valorTotalVencido,
                  this.itensCards.res.financeiroPeriodoAnterior
                    .valorTotalVencido,
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>

            <div
              class="vx-col p-2 w-full lg:w-3/12"
              @click="exibeResumoPropostas('Não Gerados')"
            >
              <statistics-card
                iconPack="feather"
                icon="icon-minus-circle"
                color="#872e27"
                bg="#ffcbca"
                :titulo="`${this.itensCards.res.financeiroPeriodo.qtdTotalNaoGerados} Boletos Não Gerados`"
                :valorTotal="`${formataReal(
                  this.itensCards.res.financeiroPeriodo.valorTotalNaoGerados,
                )}`"
                :valorTotalAnterior="`${formataReal(
                  this.itensCards.res.financeiroPeriodoAnterior
                    .valorTotalNaoGerados,
                )}`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.financeiroPeriodo.valorTotalNaoGerados,
                  this.itensCards.res.financeiroPeriodoAnterior
                    .valorTotalNaoGerados,
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>
          </div>
          <div class="mt-4 mb-6 flex justify-center">
            <div class="swiper-pagination flex gap-3" slot="pagination"></div>
          </div>
        </div>
      </vx-card>

      <vx-card
        v-if="itensCards.res"
        title="Analiticos"
        class="bg-secondary mb-5"
      >
        <div class="carousel-statistic">
          <div class="vx-row">
            <div
              class="vx-col p-2 w-full lg:w-3/12"
              @click="exibeResumoPropostas('Todas')"
            >
              <statistics-card
                iconPack="feather"
                icon="icon-briefcase"
                color="#29C770"
                bg="#E3F7EA"
                titulo="Total de Cotações"
                :valorTotal="`${this.itensCards.res.propostasPeriodo.qtdTotalPropostas}`"
                :valorTotalAnterior="`${this.itensCards.res.propostasPeriodoAnterior.qtdTotalPropostas}`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.propostasPeriodo.qtdTotalPropostas,
                  this.itensCards.res.propostasPeriodoAnterior
                    .qtdTotalPropostas,
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>
            <div class="vx-col p-2 w-full lg:w-3/12">
              <statistics-card
                iconPack="feather"
                icon="icon-activity"
                color="#6800CF"
                bg="#FDE2F7"
                titulo="Placas Ativas"
                :valorTotal="`${this.itensCards.res.veiculosAtivosPeriodo}`"
                :valorTotalAnterior="`${this.itensCards.res.veiculosAtivosPeriodoAnterior}`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.veiculosAtivosPeriodo,
                  this.itensCards.res.veiculosAtivosPeriodoAnterior,
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>

            <div class="vx-col p-2 w-full lg:w-3/12">
              <statistics-card
                iconPack="feather"
                icon="icon-percent"
                color="#FF9E43"
                bg="#FFF0E5"
                titulo="Taxa de Conversão"
                :valorTotal="`${(
                  (this.itensCards.res.veiculosAtivosPeriodo * 100) /
                  this.itensCards.res.propostasPeriodo.qtdTotalPropostas
                ).toFixed(2)}%`"
                :valorTotalAnterior="`${(
                  (this.itensCards.res.veiculosAtivosPeriodoAnterior * 100) /
                  this.itensCards.res.propostasPeriodoAnterior.qtdTotalPropostas
                ).toFixed(2)}%`"
                :txCrescimento="`${(
                  (this.itensCards.res.veiculosAtivosPeriodo * 100) /
                    this.itensCards.res.propostasPeriodo.qtdTotalPropostas -
                  (this.itensCards.res.veiculosAtivosPeriodoAnterior * 100) /
                    this.itensCards.res.propostasPeriodoAnterior
                      .qtdTotalPropostas
                ).toFixed(2)}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>

            <div class="vx-col p-2 w-12/12"></div>
            <div class="vx-col p-2 w-full lg:w-3/12">
              <statistics-card
                iconPack="feather"
                icon="icon-activity"
                color="#872e27"
                bg="#ffcbca"
                titulo="Placas Ativas Não Pagas"
                :valorTotal="`${
                  this.itensCards.res.veiculosAtivosPeriodo -
                  this.itensCards.res.veiculosAtivosPagosPeriodo
                }`"
                :valorTotalAnterior="`${
                  this.itensCards.res.veiculosAtivosPeriodoAnterior -
                  this.itensCards.res.veiculosAtivosPagosPeriodoAnterior
                }`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.veiculosAtivosPeriodo -
                    this.itensCards.res.veiculosAtivosPagosPeriodo,
                  this.itensCards.res.veiculosAtivosPeriodoAnterior -
                    this.itensCards.res.veiculosAtivosPagosPeriodoAnterior,
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>
            <div class="vx-col p-2 w-full lg:w-3/12">
              <statistics-card
                iconPack="feather"
                icon="icon-activity"
                color="#29C770"
                bg="#E3F7EA"
                titulo="Placas Ativas Pagaram"
                :valorTotal="`${this.itensCards.res.veiculosAtivosPagosPeriodo}`"
                :valorTotalAnterior="`${this.itensCards.res.veiculosAtivosPagosPeriodoAnterior}`"
                :txCrescimento="`${calculaCrescimento(
                  this.itensCards.res.veiculosAtivosPagosPeriodo,
                  this.itensCards.res.veiculosAtivosPagosPeriodoAnterior,
                  true,
                )}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>

            <div class="vx-col p-2 w-full lg:w-3/12">
              <statistics-card
                iconPack="feather"
                icon="icon-percent"
                color="#29C770"
                bg="#E3F7EA"
                titulo="Taxa de Conversão que Pagaram"
                :valorTotal="`${(
                  (this.itensCards.res.veiculosAtivosPagosPeriodo * 100) /
                  this.itensCards.res.propostasPeriodo.qtdTotalPropostas
                ).toFixed(2)}%`"
                :valorTotalAnterior="`${(
                  (this.itensCards.res.veiculosAtivosPagosPeriodoAnterior *
                    100) /
                  this.itensCards.res.propostasPeriodoAnterior.qtdTotalPropostas
                ).toFixed(2)}%`"
                :txCrescimento="`${(
                  (this.itensCards.res.veiculosAtivosPagosPeriodo * 100) /
                    this.itensCards.res.propostasPeriodo.qtdTotalPropostas -
                  (this.itensCards.res.veiculosAtivosPagosPeriodoAnterior *
                    100) /
                    this.itensCards.res.propostasPeriodoAnterior
                      .qtdTotalPropostas
                ).toFixed(2)}%`"
                :periodoAnterior="`${itensCards.dataInicialAnterior} à ${itensCards.dataFinalAnterior}`"
              ></statistics-card>
            </div>
          </div>
          <div class="mt-4 mb-6 flex justify-center">
            <div class="swiper-pagination flex gap-3" slot="pagination"></div>
          </div>
        </div>
      </vx-card>

      <Modal
        class="modalPropostaStyle"
        :active.sync="modalResumoFinanceiro"
        :title="`Resumo Financeiro`"
      >
        <div class="w-full flex p-3 justify-center">
          <div></div>
          <div class="w-full">
            <div class="vx-row m-0 w-full text-left flex justify-between p-2">
              <div class="vx-col font-bold p-0 w-2/12">VENCIMENTO</div>
              <div class="vx-col font-bold p-0 w-2/12 lg:block hidden">
                VALOR
              </div>
              <div class="vx-col font-bold p-0 w-3/12">SEGURADO</div>
              <div class="vx-col font-bold p-0 w-3/12">CORRETOR</div>
              <div class="vx-col font-bold lg:flex justify-end p-0 w-2/12">
                STATUS
              </div>
            </div>
            <ul>
              <li v-for="item in financeiroResumo" :key="item.index">
                <div
                  class="vx-row m-0 w-full text-left flex justify-between p-2"
                >
                  <div class="vx-col p-0 w-2/12">
                    {{ formataDataMomentJS(item.data_vencimento) }}
                  </div>
                  <div class="vx-col p-0 w-2/12 lg:block hidden">
                    {{ formataReal(item.valor_boleto) }}
                  </div>
                  <div class="vx-col p-2 w-full lg:w-3/12">
                    <a
                      target="_blank"
                      style="color: inherit"
                      :href="`${preLink}/DetalheSegurado/${item.id_prospect}`"
                      class="nomeAssociadoModal font-semibold"
                    >
                      {{ item.associado }}
                      <vs-icon
                        color="primary"
                        icon-pack="feather"
                        icon="icon-external-link"
                      >
                      </vs-icon>
                    </a>
                  </div>
                  <div class="vx-col p-2 w-full lg:w-3/12">
                    {{ item.consultor }} <br />
                    {{ item.regional }}<br />
                    {{ item.divisao }}
                  </div>
                  <div class="vx-col lg:flex justify-end p-0 w-2/12">
                    <vs-chip :color="getStatusColorFinanceiro(item.situacao)">
                      <p class="fontChip">
                        {{ item.situacao }}
                      </p>
                    </vs-chip>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </Modal>

      <Modal
        class="modalPropostaStyle"
        :active.sync="modalResumoProposta"
        :title="`Resumo Propostas`"
      >
        <div class="w-full flex p-3 justify-center">
          <div></div>
          <div class="w-full">
            <div class="vx-row m-0 w-full text-left flex justify-between p-2">
              <div class="vx-col font-bold p-0 w-1/12">ID</div>
              <div class="vx-col font-bold p-0 w-1/12">PLACA</div>
              <div class="vx-col font-bold p-0 w-3/12 lg:block hidden">
                VEÍCULO
              </div>
              <div class="vx-col font-bold p-0 w-3/12">ASSOCIADO</div>
              <div class="vx-col font-bold p-0 w-3/12">CONSULTOR</div>
              <div class="vx-col font-bold lg:flex justify-end p-0 w-1/12">
                STATUS
              </div>
            </div>
            <ul>
              <li v-for="item in propostasResumo" :key="item.index">
                <div
                  class="vx-row m-0 w-full text-left flex justify-between p-2"
                >
                  <div class="vx-col p-0 w-1/12">
                    <a
                      style="color: inherit"
                      target="_blank"
                      :href="`${preLink}/proposta/${item.chave}?interno=true`"
                      class="cursor-pointer"
                    >
                      {{ item.id_proposta }}
                      <vs-icon
                        color="primary"
                        icon-pack="feather"
                        icon="icon-external-link"
                      >
                      </vs-icon>
                    </a>
                  </div>
                  <div class="vx-col p-0 w-1/12">{{ item.placa }}</div>
                  <div class="vx-col p-0 w-3/12 lg:block hidden">
                    {{ item.veiculoMarca }} <br />
                    {{ item.veiculoModelo }}
                  </div>
                  <div class="vx-col p-2 w-full lg:w-3/12">
                    <a
                      target="_blank"
                      style="color: inherit"
                      :href="`${preLink}/DetalheSegurado/${item.id_prospect}`"
                      class="nomeAssociadoModal font-semibold"
                    >
                      {{ item.associado }}
                      <vs-icon
                        color="primary"
                        icon-pack="feather"
                        icon="icon-external-link"
                      >
                      </vs-icon>
                    </a>
                  </div>
                  <div class="vx-col p-2 w-full lg:w-3/12">
                    {{ item.consultor }} <br />
                    {{ item.regional }}<br />
                    {{ item.divisao }}
                  </div>
                  <div class="vx-col lg:flex justify-end p-0 w-1/12">
                    <vs-chip :color="getStatusColor(item.id_Status)">
                      <p class="fontChip">
                        {{ item.nomeStatus }}
                      </p>
                    </vs-chip>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </Modal>

      <vs-card class="semDados lg:hidden block" v-if="itens.length == 0">
        <h5>Não há dados para exibir!</h5>
      </vs-card>
      <div class="lg:hidden block" v-for="item in itens" :key="item.index">
        <div class="relative pb-4 mb-6">
          <vs-card>
            <div class="vx-row">
              <div class="vx-col w-full flex flex-wrap mt-2 mb-2">
                <div class="vx-col w-1/2 p-1">
                  <p class="titleCard">USUÁRIO</p>
                  <p class="subtitleCard">{{ item.usuario }}</p>
                </div>
                <div class="vx-col w-1/2 p-1">
                  <p class="titleCard">CORRETORA</p>
                  <p class="subtitleCard">{{ item.regional }}</p>
                </div>
                <div class="vx-col w-1/2 p-1">
                  <p class="titleCard">ASSESSORIA</p>
                  <p class="subtitleCard">{{ item.divisao }}</p>
                </div>
                <div class="vx-col w-1/2 p-1">
                  <p class="titleCard">PROPOSTAS</p>
                  <p class="subtitleCard">{{ item.qtdGeral }}</p>
                </div>
                <div class="vx-col w-1/2 p-1">
                  <p class="titleCard">TOTAL DE VENDAS</p>
                  <p class="subtitleCard">{{ item.qtdFinalizadas }}</p>
                </div>
                <div class="vx-col w-1/2 p-1">
                  <p class="titleCard">TAXA DE CONVERSÃO</p>
                  <p class="subtitleCard">{{ item.taxaConversao }}%</p>
                </div>
              </div>
            </div>
          </vs-card>
          <div class="expandirCotacoes vx-col">
            <vs-button
              color="#E9E9E9"
              text-color="#374957"
              icon-pack="feather"
              icon="icon-maximize-2"
              icon-after
              class="buttonExpandirCotacoes w-full z-0 text-base font-semibold"
              @click="buscaCotacoes(item)"
              >Detalhes</vs-button
            >
          </div>
        </div>
      </div>

      <template lang="html">
        <div class="listRelatorioConsolidado lg:block hidden">
          <vs-table
            noDataText="Não há dados para exibir!"
            @selected="buscaCotacoes"
            stripe
            :data="itens"
          >
            <template slot="thead">
              <vs-th class="w-1/4" sort-key="usuario"> USUÁRIO Usuário </vs-th>
              <vs-th class="w-1/4" sort-key="regional"> CORRETORA </vs-th>
              <vs-th class="w-1/5" sort-key="divisao"> ASSESSORIA </vs-th>
              <vs-th class="w-1/12" sort-key="qtdGeral"> PROPOSTAS </vs-th>
              <vs-th class="w-1/12" sort-key="qtdFinalizadas">
                TOTAL DE VENDAS
              </vs-th>
              <vs-th class="w-1/12" sort-key="taxaConversao">
                TAXA DE CONVERSÃO
              </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td class="w-1/4">
                  <vs-icon icon-pack="feather" icon="icon-plus-circle">
                  </vs-icon>
                  {{ tr.usuario }}
                </vs-td>

                <vs-td class="w-1/4">
                  {{ tr.regional }}
                </vs-td>

                <vs-td class="w-1/5">
                  {{ tr.divisao }}
                </vs-td>

                <vs-td class="w-1/12 text-right pr-4">
                  {{ tr.qtdGeral }}
                </vs-td>

                <vs-td class="w-1/12 text-right pr-4">
                  {{ tr.qtdFinalizadas }}
                </vs-td>

                <vs-td class="w-1/12 text-right pr-4">
                  {{ tr.taxaConversao.toFixed(2) }}%
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <Modal
            class="modalPropostaStyle"
            :active.sync="modalPropostas"
            title="propostas"
          >
            <div class="w-full flex p-3 justify-center">
              <div></div>
              <div class="w-full">
                <div
                  class="vx-row m-0 w-full text-left flex justify-between p-2"
                >
                  <div class="vx-col font-bold p-0 w-1/12">ID</div>
                  <div class="vx-col font-bold p-0 w-1/12">PLACA</div>
                  <div class="vx-col font-bold p-0 lg:w-1/5 lg:block hidden">
                    CHASSI
                  </div>
                  <div class="vx-col font-bold p-0 w-2/5 lg:w-1/4">
                    ASSOCIADO
                  </div>
                  <div
                    class="vx-col font-bold lg:flex justify-end p-0 sm:w-1/6 w-1/5"
                  >
                    STATUS
                  </div>
                </div>
                <ul>
                  <li v-for="item in dadosProposta" :key="item.index">
                    <div
                      class="vx-row m-0 w-full text-left flex justify-between p-2"
                    >
                      <a
                        style="color: inherit"
                        target="_blank"
                        :href="`${preLink}/proposta/${item.chave}?interno=true`"
                        class="vx-col p-0 font-semibold w-1/12 cursor-pointer"
                      >
                        {{ item.id_proposta }}
                        <vs-icon
                          color="primary"
                          icon-pack="feather"
                          icon="icon-external-link"
                        >
                        </vs-icon>
                      </a>

                      <div class="vx-col p-0 w-1/12">
                        {{ item.placa }}
                      </div>
                      <div class="vx-col p-0 w-1/5 lg:block hidden">
                        {{ item.chassi }}
                      </div>

                      <a
                        target="_blank"
                        style="color: inherit"
                        :href="`${preLink}/DetalheSegurado/${item.id_prospect}`"
                        class="nomeAssociadoModal vx-col p-0 w-2/5 lg:w-1/4 cursor-pointer font-semibold"
                      >
                        {{ item.nome }}
                        <vs-icon
                          color="primary"
                          icon-pack="feather"
                          icon="icon-external-link"
                        >
                        </vs-icon>
                      </a>

                      <div
                        class="vx-col p-0 lg:w-1/6 w-1/5 flex items-center justify-end"
                      >
                        <vs-chip :color="getStatusColor(item.nomeStatus)">
                          <p class="fontChip">
                            {{ item.nomeStatus }}
                          </p>
                        </vs-chip>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </Modal>
        </div>
      </template>
    </div>
    <div v-else>
      <vs-card
        ><div class="p-8 flex justify-center">
          <h5 class="lg:flex text-center gap-2" style="color: red">
            É necessário ter permissão de
            <h4>"Leitura Carteira Completa"</h4>
            ou
            <h4>"Leitura Carteira Corretora"</h4>
            para continuar!
          </h5>
        </div></vs-card
      >
    </div>
  </div>
</template>

<script>
import StatisticsCard from '@/components/statistics-cards/StatisticsCard.vue';
import Filtro from './../../filtros/FiltroPainelVendas';
import 'swiper/dist/css/swiper.min.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import service from '../../../services';
import moment from 'moment';
import functions from '../../../utils/functions';
import { STATUS_PROPOSTA } from '../../../utils/constants';
import Modal from '../../../components/Modal.vue';

export default {
  name: 'ConsolidadoRelatorio',
  components: {
    Filtro,
    StatisticsCard,
    swiper,
    swiperSlide,
    Modal,
  },
  data() {
    return {
      STATUS_PROPOSTA,
      realizaFiltro: false,
      filtro: null,
      carregado: null,
      objSend: {},
      itens: [],
      itensCards: {},
      dadosProposta: [],
      functions: functions,
      modalResumoFinanceiro: false,
      modalResumoProposta: false,
      modalPropostas: false,
      preLink: null,
      financeiroResumo: [],
      propostasResumo: [],
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 20,
        simulateTouch: false,
        watchSlideProgress: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          1400: {
            slidesPerView: 3,
            spaceBetween: 20,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 20,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
          },
        },
      },
    };
  },

  methods: {
    exibeResumoPropostas(tipo) {
      this.$vs.loading();
      this.propostasResumo = [];
      setTimeout(() => {
        this.propostasResumo = [...this.itensCards.res.propostasResumo];
        if (tipo == 'Não Gerados') {
          this.propostasResumo = [
            ...this.itensCards.res.boletosNaoGeradosResumo,
          ];
        } else if (tipo != 'Todas')
          this.propostasResumo = this.propostasResumo.filter(
            (x) => x.nomeStatus == tipo,
          );
      }, 1000);

      setTimeout(() => {
        this.modalPropostas = false;
        this.modalResumoFinanceiro = false;
        this.modalResumoProposta = true;
        this.$vs.loading.close();
      }, 1000);
    },
    exibeResumoFinanceiro(tipo) {
      this.$vs.loading();
      this.financeiroResumo = [];
      setTimeout(() => {
        this.financeiroResumo = [...this.itensCards.res.financeiroResumo];
        if (tipo == 'Pagos') {
          this.financeiroResumo = this.financeiroResumo.filter(
            (x) => x.situacao == 'BAIXADO',
          );
        }
        if (tipo == 'Em Aberto') {
          this.financeiroResumo = this.financeiroResumo.filter(
            (x) => x.situacao == 'ABERTO',
          );
        }
        if (tipo == 'Vencidos') {
          this.financeiroResumo = this.financeiroResumo.filter(
            (x) => x.situacao == 'VENCIDO',
          );
        }
      }, 1000);

      setTimeout(() => {
        this.modalPropostas = false;
        this.modalResumoFinanceiro = true;
        this.modalResumoProposta = false;
        this.$vs.loading.close();
      }, 1000);
    },
    buscaDados() {
      this.buscaDadosVendasFiltro();
    },
    calculaCrescimento(valorAtual, valorAnterior, arredonda) {
      let valorFinal = 0;
      valorFinal = ((valorAtual - valorAnterior) * 100) / valorAnterior;
      //if (valorAtual < valorAnterior) valorFinal = (valorFinal - 100) * -1;
      if (valorAnterior == 0) valorFinal = 100;
      if (valorAnterior == valorAtual) valorFinal = 0;
      if (arredonda == true) valorFinal = valorFinal.toFixed(2);

      return valorFinal;
    },
    buscaDadosVendasFiltro() {
      this.carregado = false;
      this.$vs.loading();
      var objSend = { ...this.objSend };

      service
        .post('Relatorios', 'relatorioConsolidado', objSend)
        .then((res) => {
          this.itens = [];
          if (res.data.result) {
            res.data.result.forEach((element) => {
              for (let key in element) {
                if (element[key] === null) {
                  element[key] = 0;
                }
              }
              this.itens.push(element);
            });
          }

          this.itensCards = res.data.cards;
          for (const key in this.itensCards.res.propostasPeriodo) {
            if (this.itensCards.res.propostasPeriodo[key] === null)
              this.itensCards.res.propostasPeriodo[key] = 0;
          }

          for (const key in this.itensCards.res.propostasPeriodoAnterior) {
            if (this.itensCards.res.propostasPeriodoAnterior[key] === null)
              this.itensCards.res.propostasPeriodoAnterior[key] = 0;
          }

          for (const key in this.itensCards.res.financeiroPeriodo) {
            if (this.itensCards.res.financeiroPeriodo[key] === null)
              this.itensCards.res.financeiroPeriodo[key] = 0;
          }

          for (const key in this.itensCards.res.financeiroPeriodoAnterior) {
            if (this.itensCards.res.financeiroPeriodoAnterior[key] === null)
              this.itensCards.res.financeiroPeriodoAnterior[key] = 0;
          }

          this.carregado = true;
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possivel carregar os dados do Gráfico',
            color: 'danger',
          });
        });
    },
    makeFiltro(filtro) {
      this.realizaFiltro = true;
      this.filtro = filtro;
      this.filtraGeral();
    },
    filtraGeral() {
      this.preparaFiltro();
      this.buscaDados();
    },
    finalizaFiltro() {
      this.realizaFiltro = false;
    },
    preparaFiltro() {
      this.objSend = {};

      if (this.filtro) {
        this.objSend = { ...this.filtro };
        this.objSend.dataInicial = moment(this.filtro.dataInicial)
          .utc()
          .format('DD/MM/YYYY');

        this.objSend.dataFinal = moment(this.filtro.dataFinal)
          .utc()
          .format('DD/MM/YYYY');

        if (!this.filtro.editarPeriodoAnterior) {
          const dataInicialMoment = moment(
            this.objSend.dataInicial,
            'DD/MM/YYYY',
          );
          const dataFinalMoment = moment(this.objSend.dataFinal, 'DD/MM/YYYY');

          const diferencaDias = dataFinalMoment.diff(dataInicialMoment, 'days');

          this.filtro.dataInicialAnterior = dataInicialMoment
            .clone()
            .subtract(diferencaDias, 'days')
            .format('YYYY-MM-DD');

          this.filtro.dataFinalAnterior = dataInicialMoment
            .clone()
            .subtract(1, 'days')
            .format('YYYY-MM-DD');
        }
        this.objSend.dataInicialAnterior = moment(
          this.filtro.dataInicialAnterior,
        )
          .utc()
          .format('DD/MM/YYYY');

        this.objSend.dataFinalAnterior = moment(this.filtro.dataFinalAnterior)
          .utc()
          .format('DD/MM/YYYY');
      }
    },

    async buscaCotacoes(tr) {
      this.selected = [];
      this.$vs.loading();
      let objSend = { ...tr };
      if (this.filtro) {
        objSend.dataInicial = this.filtro.dataInicial;
        objSend.dataFinal = this.filtro.dataFinal;
        objSend.dataInicial = moment(this.filtro.dataInicial)
          .utc()
          .format('DD/MM/YYYY');

        objSend.dataFinal = moment(this.filtro.dataFinal)
          .utc()
          .format('DD/MM/YYYY');
      } else {
        this.objSend.dataInicial = moment()
          .startOf('month')
          .format('DD/MM/YYYY');

        this.objSend.dataFinal = moment().endOf('month').format('DD/MM/YYYY');
        objSend.dataFinal = moment().format('YYYY-MM-DD');
      }

      objSend.idEmpresa = +localStorage.getItem('idEmpresa');

      service
        .post('Relatorios', 'relatorioConsolidadoPropostas', objSend)
        .then((res) => {
          this.dadosProposta = [];
          res.data.forEach((element) => {
            this.dadosProposta.push(element);
          });
          this.$vs.loading.close();
          this.modalPropostas = true;
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    getStatusColor(data) {
      return functions.getStatusColor(data);
    },
    getStatusColorFinanceiro(data) {
      if (data == 'BAIXADO') return 'success';
      if (data == 'ABERTO') return 'warning';
      if (data == 'VENCIDO') return 'danger';
    },
    formataDataMomentJS(data) {
      return functions.formataDataMomentJS(data, 'DD/MM/YYYY');
    },
    formataReal(data) {
      return functions.formataReal(data);
    },
  },

  mounted() {
    this.screenWidth = window.innerWidth;
    this.preLink = window.location.origin;
  },
};
</script>

<style>
.botaoExpandir {
  position: absolute;
  right: 5px;
  margin-top: -25px;
}
.bg-secondary {
  background: #0099dd;
}
.bg-secondary2 {
  background: #00abbd;
}
.bg-secondary3 {
  background: #a1c7e0;
}
.semDados {
  text-align: center;
}
.fontChip {
  font-size: 12px;
}
.semDados h5 {
  margin-bottom: 0;
  padding: 25px 0;
}
.listRelatorioConsolidado .vs-con-table .vs-con-tbody {
  border-radius: 15px;
}
.titleCard {
  color: #0090cf;
  font-size: 11px;
  margin-bottom: 4px;
  font-weight: 600;
}
.subtitleCard {
  color: #2d2d2d;
  font-size: 13px;
}
.listRelatorioConsolidado th {
  background-color: #e2f6fd;
  color: #0090cf;
}

.listRelatorioConsolidado th .sort-th i {
  color: #0090cf;
  font-size: 1rem;
}
.listRelatorioConsolidado th .sort-th {
  gap: 8px;
}
.listRelatorioConsolidado
  .vs-con-table
  .vs-con-tbody
  .vs-table--tbody-table
  .vs-table--thead
  th {
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}
.buttonExpandirCotacoes .vs-icon {
  font-size: 15px;
}
.modalPropostaStyle ul li:nth-child(odd) {
  background-color: rgb(241, 240, 240);
  border-radius: 5px;
}
.nomeAssociadoModal {
  overflow: hidden;
  word-wrap: break-word;
}
@media screen and (max-width: 700px) {
  .modalPropostaStyle.con-vs-popup .vs-popup--content {
    padding: 0;
    margin: 0;
    font-size: 0.9rem;
  }
  .fontChip {
    font-size: 7px;
    font-weight: 600;
  }
}
@media screen and (min-width: 900px) {
  .modalPropostaStyle.con-vs-popup .vs-popup {
    width: 60%;
  }
}
</style>
<style lang="scss">
@media print {
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
}
</style>
<style scoped src="../../../assets/css/listCard.css"></style>
